module.exports = __webpack_public_path__ + "img/estacio.ac23ed84.jpg";